import React from 'react'
import SupplyOrderBillList from './SupplyOrderBillList'

const SupplyOrderBills = ({ supplyOrderId }) => {
  return (
    <div className='supplyOrderView__bills'>
        <h4>Рахунки</h4>
		<SupplyOrderBillList 
			supplyOrderId={supplyOrderId}
		/>
    </div>
  )
}

export default SupplyOrderBills